import action from './action'
import children from './children'
import component from './component'
import layout from './layout'
import reference from './reference'
import derivePropTypeFromValueOf from './derivePropTypeFromValueOf'
import mutuallyExclusiveProps from './mutuallyExclusiveProps'
import mutuallyExclusiveProperties from './mutuallyExclusiveProperties'

export {
  action,
  children,
  component,
  layout,
  reference,
  derivePropTypeFromValueOf,
  mutuallyExclusiveProps,
  mutuallyExclusiveProperties
}

export default {
  action,
  children,
  component,
  layout,
  reference,
  derivePropTypeFromValueOf,
  mutuallyExclusiveProps,
  mutuallyExclusiveProperties
}
